export default __webpack_public_path__ + "static/media/BrixSansMedium.b53df5be.woff";